// extracted by mini-css-extract-plugin
module.exports = {"root":"ArticleUtilityBar_root__fMTYg"};